// extracted by mini-css-extract-plugin
export default {"audio":"Audio_audio__URuvT","audio__caption":"Audio_audio__caption__kYLfe"};